import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginPageStateService {
  private isModalViewOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  setIsModalViewOpen(isModalViewOpen: boolean): void {
    this.isModalViewOpen.next(isModalViewOpen);
  }

  getIsModalViewOpen(): boolean {
    return this.isModalViewOpen.getValue();
  }
}
